// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating feedback ticket widget aligned with the support theme. */

.feedbackpopup-toggle,
.feedbackpopup-dialog {
  --feedback-surface: #fffdf8;
  --feedback-surface-strong: #ffffff;
  --feedback-surface-soft: #fbf6ed;
  --feedback-paper: #ede1d1;
  --feedback-muted: #6f6a60;
  --feedback-muted-2: #948c7e;
  --feedback-text: #172119;
  --feedback-border: #e7dccc;
  --feedback-border-strong: #d5c4af;
  --feedback-primary: #214734;
  --feedback-primary-600: #173326;
  --feedback-accent: #c89a3c;
  --feedback-clay: #a86444;
  --feedback-danger: #ef4444;
  --feedback-radius: 8px;
  --feedback-shadow: 0 22px 60px rgba(47, 39, 29, 0.12);
  --feedback-shadow-2: 0 12px 30px rgba(47, 39, 29, 0.08);
  --feedback-focus: rgba(33, 71, 52, 0.18);
  --feedback-font-display: Georgia, "Times New Roman", serif;
  --feedback-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.feedbackpopup-toggle {
  position: fixed;
  right: calc(18px + env(safe-area-inset-right, 0px));
  bottom: calc(18px + env(safe-area-inset-bottom, 0px));
  z-index: 9999;
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  min-height: 54px;
  padding: 0;
  border: 1px solid var(--feedback-primary);
  border-radius: 999px;
  background: var(--feedback-primary);
  color: #ffffff;
  cursor: pointer;
  font-family: var(--feedback-font-sans);
  font-size: 0.9rem;
  font-weight: 850;
  line-height: 1.2;
  box-shadow: 0 18px 34px rgba(33, 71, 52, 0.28);
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.06s ease;
}

.feedbackpopup-toggle:hover,
.feedbackpopup-toggle:focus-visible {
  border-color: var(--feedback-primary-600);
  background: var(--feedback-primary-600);
  box-shadow: 0 20px 38px rgba(33, 71, 52, 0.32);
}

.feedbackpopup-toggle:active {
  transform: translateY(1px);
}

.feedbackpopup-toggle-icon {
  width: 24px;
  height: 24px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.feedbackpopup-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.feedbackpopup-dialog {
  position: relative;
  width: min(92vw, 430px);
  max-width: 430px;
  padding: 22px;
  border: 1px solid rgba(91, 72, 48, 0.16);
  border-radius: var(--feedback-radius);
  background:
    linear-gradient(135deg, rgba(255, 253, 248, 0.98), rgba(241, 230, 212, 0.92)),
    var(--feedback-surface);
  box-shadow: var(--feedback-shadow);
  color: var(--feedback-text);
  font-family: var(--feedback-font-sans);
  animation: feedbackpopup-fade 0.22s ease;
}

.feedbackpopup-dialog::backdrop {
  background: rgba(23, 33, 25, 0.44);
}

.feedbackpopup-form {
  display: grid;
  grid-gap: 14px;
  gap: 14px;
}

.feedbackpopup-form h2,
.feedbackpopup-thanks h2 {
  margin: 0;
  color: var(--feedback-text);
  font-family: var(--feedback-font-display);
  font-size: 1.7rem;
  font-weight: 500;
  line-height: 1.05;
  letter-spacing: 0;
}

.feedbackpopup-form label {
  display: grid;
  grid-gap: 6px;
  gap: 6px;
  color: var(--feedback-muted);
  font-size: 0.9rem;
  font-weight: 800;
}

.feedbackpopup-form select,
.feedbackpopup-form textarea {
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid var(--feedback-border);
  border-radius: var(--feedback-radius);
  outline: none;
  background: var(--feedback-surface-strong);
  color: var(--feedback-text);
  font: inherit;
  font-size: 0.92rem;
  font-weight: 650;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.feedbackpopup-form textarea {
  min-height: 110px;
  line-height: 1.45;
  resize: vertical;
}

.feedbackpopup-form select:focus,
.feedbackpopup-form textarea:focus {
  border-color: rgba(18, 63, 42, 0.3);
  box-shadow: 0 0 0 4px var(--feedback-focus);
}

.feedbackpopup-form menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin: 2px 0 0;
  padding: 0;
}

.feedbackpopup-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--feedback-border);
  border-radius: var(--feedback-radius);
  cursor: pointer;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1.2;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    transform 0.06s ease;
}

.feedbackpopup-btn:active {
  transform: translateY(1px);
}

.feedbackpopup-submit {
  border-color: var(--feedback-primary);
  background: var(--feedback-primary);
  color: #ffffff;
}

.feedbackpopup-submit:hover,
.feedbackpopup-submit:focus-visible {
  border-color: var(--feedback-primary-600);
  background: var(--feedback-primary-600);
}

.feedbackpopup-submit.invalid {
  border-color: var(--feedback-border-strong);
  background: var(--feedback-surface-soft);
  color: var(--feedback-muted);
}

.feedbackpopup-submit.invalid:hover,
.feedbackpopup-submit.invalid:focus-visible {
  border-color: rgba(239, 68, 68, 0.42);
  color: var(--feedback-text);
}

.feedbackpopup-cancel {
  background: rgba(255, 253, 248, 0.9);
  color: var(--feedback-primary);
}

.feedbackpopup-cancel:hover,
.feedbackpopup-cancel:focus-visible {
  border-color: var(--feedback-border-strong);
  background: var(--feedback-surface-strong);
  color: var(--feedback-primary-600);
}

.feedbackpopup-agree-row {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  align-items: start;
  grid-gap: 10px;
  gap: 10px;
  color: var(--feedback-muted);
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.45;
}

.feedbackpopup-agree-row input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 2px 0 0;
  accent-color: var(--feedback-primary);
  cursor: pointer;
}

.feedbackpopup-error {
  border-color: rgba(239, 68, 68, 0.55) !important;
  background: rgba(239, 68, 68, 0.06) !important;
}

.feedbackpopup-error-checkbox {
  outline: 2px solid rgba(239, 68, 68, 0.7);
  outline-offset: 2px;
}

.feedbackpopup-error-text {
  margin-top: 2px;
  color: var(--feedback-danger);
  font-size: 0.78rem;
  font-weight: 800;
}

.feedbackpopup-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: var(--feedback-radius);
  background: rgba(255, 253, 248, 0.9);
  animation: feedbackpopup-fade 0.22s ease;
}

.feedbackpopup-overlay p {
  margin: 12px 0 0;
  color: var(--feedback-muted);
  font-size: 0.9rem;
  font-weight: 800;
}

.feedbackpopup-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ede1d1;
  border: 4px solid var(--feedback-paper, #ede1d1);
  border-top-color: var(--feedback-primary);
  border-radius: 50%;
  animation: feedbackpopup-spin 1s linear infinite;
}

.feedbackpopup-thanks {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
  justify-items: center;
  text-align: center;
  animation: feedbackpopup-fade 0.22s ease;
}

.feedbackpopup-thanks p {
  margin: 0;
  color: var(--feedback-muted);
  font-weight: 700;
}

@keyframes feedbackpopup-spin {
  to { transform: rotate(360deg); }
}

@keyframes feedbackpopup-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 520px) {
  .feedbackpopup-toggle {
    top: auto;
    right: 12px;
    bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    min-height: 40px;
    padding: 9px 12px;
    border-radius: 8px;
    transform: none;
    writing-mode: horizontal-tb;
  }

  .feedbackpopup-toggle:active {
    transform: translateY(1px);
  }

  .feedbackpopup-form menu {
    display: grid;
    grid-template-columns: 1fr;
  }

  .feedbackpopup-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/FeedbackWidget.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;;EAEE,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,iCAAiC;EACjC,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,qDAAqD;EACrD,uDAAuD;EACvD,wCAAwC;EACxC,0DAA0D;EAC1D,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,mDAAmD;EACnD,qDAAqD;EACrD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,uGAAuG;AACzG;;AAEA;;EAEE,yCAAyC;EACzC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,qCAAqC;EACrC;;2BAEyB;EACzB,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,2BAA2B;EAC3B,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAQ;EAAR,QAAQ;EACR,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;EACrC,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB;;;;wBAIsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;;EAEE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,cAAS;EAAT,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAgD;EAAhD,gDAAgD;EAChD,yCAAyC;EACzC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,qDAAqD;IACrD,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Floating feedback ticket widget aligned with the support theme. */\n\n.feedbackpopup-toggle,\n.feedbackpopup-dialog {\n  --feedback-surface: #fffdf8;\n  --feedback-surface-strong: #ffffff;\n  --feedback-surface-soft: #fbf6ed;\n  --feedback-paper: #ede1d1;\n  --feedback-muted: #6f6a60;\n  --feedback-muted-2: #948c7e;\n  --feedback-text: #172119;\n  --feedback-border: #e7dccc;\n  --feedback-border-strong: #d5c4af;\n  --feedback-primary: #214734;\n  --feedback-primary-600: #173326;\n  --feedback-accent: #c89a3c;\n  --feedback-clay: #a86444;\n  --feedback-danger: #ef4444;\n  --feedback-radius: 8px;\n  --feedback-shadow: 0 22px 60px rgba(47, 39, 29, 0.12);\n  --feedback-shadow-2: 0 12px 30px rgba(47, 39, 29, 0.08);\n  --feedback-focus: rgba(33, 71, 52, 0.18);\n  --feedback-font-display: Georgia, \"Times New Roman\", serif;\n  --feedback-font-sans: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.feedbackpopup-toggle {\n  position: fixed;\n  right: calc(18px + env(safe-area-inset-right, 0px));\n  bottom: calc(18px + env(safe-area-inset-bottom, 0px));\n  z-index: 9999;\n  display: grid;\n  place-items: center;\n  width: 54px;\n  height: 54px;\n  min-height: 54px;\n  padding: 0;\n  border: 1px solid var(--feedback-primary);\n  border-radius: 999px;\n  background: var(--feedback-primary);\n  color: #ffffff;\n  cursor: pointer;\n  font-family: var(--feedback-font-sans);\n  font-size: 0.9rem;\n  font-weight: 850;\n  line-height: 1.2;\n  box-shadow: 0 18px 34px rgba(33, 71, 52, 0.28);\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.06s ease;\n}\n\n.feedbackpopup-toggle:hover,\n.feedbackpopup-toggle:focus-visible {\n  border-color: var(--feedback-primary-600);\n  background: var(--feedback-primary-600);\n  box-shadow: 0 20px 38px rgba(33, 71, 52, 0.32);\n}\n\n.feedbackpopup-toggle:active {\n  transform: translateY(1px);\n}\n\n.feedbackpopup-toggle-icon {\n  width: 24px;\n  height: 24px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.feedbackpopup-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.feedbackpopup-dialog {\n  position: relative;\n  width: min(92vw, 430px);\n  max-width: 430px;\n  padding: 22px;\n  border: 1px solid rgba(91, 72, 48, 0.16);\n  border-radius: var(--feedback-radius);\n  background:\n    linear-gradient(135deg, rgba(255, 253, 248, 0.98), rgba(241, 230, 212, 0.92)),\n    var(--feedback-surface);\n  box-shadow: var(--feedback-shadow);\n  color: var(--feedback-text);\n  font-family: var(--feedback-font-sans);\n  animation: feedbackpopup-fade 0.22s ease;\n}\n\n.feedbackpopup-dialog::backdrop {\n  background: rgba(23, 33, 25, 0.44);\n}\n\n.feedbackpopup-form {\n  display: grid;\n  gap: 14px;\n}\n\n.feedbackpopup-form h2,\n.feedbackpopup-thanks h2 {\n  margin: 0;\n  color: var(--feedback-text);\n  font-family: var(--feedback-font-display);\n  font-size: 1.7rem;\n  font-weight: 500;\n  line-height: 1.05;\n  letter-spacing: 0;\n}\n\n.feedbackpopup-form label {\n  display: grid;\n  gap: 6px;\n  color: var(--feedback-muted);\n  font-size: 0.9rem;\n  font-weight: 800;\n}\n\n.feedbackpopup-form select,\n.feedbackpopup-form textarea {\n  width: 100%;\n  min-height: 42px;\n  padding: 10px 12px;\n  border: 1px solid var(--feedback-border);\n  border-radius: var(--feedback-radius);\n  outline: none;\n  background: var(--feedback-surface-strong);\n  color: var(--feedback-text);\n  font: inherit;\n  font-size: 0.92rem;\n  font-weight: 650;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.feedbackpopup-form textarea {\n  min-height: 110px;\n  line-height: 1.45;\n  resize: vertical;\n}\n\n.feedbackpopup-form select:focus,\n.feedbackpopup-form textarea:focus {\n  border-color: rgba(18, 63, 42, 0.3);\n  box-shadow: 0 0 0 4px var(--feedback-focus);\n}\n\n.feedbackpopup-form menu {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin: 2px 0 0;\n  padding: 0;\n}\n\n.feedbackpopup-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--feedback-border);\n  border-radius: var(--feedback-radius);\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 800;\n  line-height: 1.2;\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease,\n    color 0.18s ease,\n    transform 0.06s ease;\n}\n\n.feedbackpopup-btn:active {\n  transform: translateY(1px);\n}\n\n.feedbackpopup-submit {\n  border-color: var(--feedback-primary);\n  background: var(--feedback-primary);\n  color: #ffffff;\n}\n\n.feedbackpopup-submit:hover,\n.feedbackpopup-submit:focus-visible {\n  border-color: var(--feedback-primary-600);\n  background: var(--feedback-primary-600);\n}\n\n.feedbackpopup-submit.invalid {\n  border-color: var(--feedback-border-strong);\n  background: var(--feedback-surface-soft);\n  color: var(--feedback-muted);\n}\n\n.feedbackpopup-submit.invalid:hover,\n.feedbackpopup-submit.invalid:focus-visible {\n  border-color: rgba(239, 68, 68, 0.42);\n  color: var(--feedback-text);\n}\n\n.feedbackpopup-cancel {\n  background: rgba(255, 253, 248, 0.9);\n  color: var(--feedback-primary);\n}\n\n.feedbackpopup-cancel:hover,\n.feedbackpopup-cancel:focus-visible {\n  border-color: var(--feedback-border-strong);\n  background: var(--feedback-surface-strong);\n  color: var(--feedback-primary-600);\n}\n\n.feedbackpopup-agree-row {\n  display: grid;\n  grid-template-columns: 22px minmax(0, 1fr);\n  align-items: start;\n  gap: 10px;\n  color: var(--feedback-muted);\n  font-size: 0.86rem;\n  font-weight: 700;\n  line-height: 1.45;\n}\n\n.feedbackpopup-agree-row input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 2px 0 0;\n  accent-color: var(--feedback-primary);\n  cursor: pointer;\n}\n\n.feedbackpopup-error {\n  border-color: rgba(239, 68, 68, 0.55) !important;\n  background: rgba(239, 68, 68, 0.06) !important;\n}\n\n.feedbackpopup-error-checkbox {\n  outline: 2px solid rgba(239, 68, 68, 0.7);\n  outline-offset: 2px;\n}\n\n.feedbackpopup-error-text {\n  margin-top: 2px;\n  color: var(--feedback-danger);\n  font-size: 0.78rem;\n  font-weight: 800;\n}\n\n.feedbackpopup-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--feedback-radius);\n  background: rgba(255, 253, 248, 0.9);\n  animation: feedbackpopup-fade 0.22s ease;\n}\n\n.feedbackpopup-overlay p {\n  margin: 12px 0 0;\n  color: var(--feedback-muted);\n  font-size: 0.9rem;\n  font-weight: 800;\n}\n\n.feedbackpopup-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--feedback-paper, #ede1d1);\n  border-top-color: var(--feedback-primary);\n  border-radius: 50%;\n  animation: feedbackpopup-spin 1s linear infinite;\n}\n\n.feedbackpopup-thanks {\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n  text-align: center;\n  animation: feedbackpopup-fade 0.22s ease;\n}\n\n.feedbackpopup-thanks p {\n  margin: 0;\n  color: var(--feedback-muted);\n  font-weight: 700;\n}\n\n@keyframes feedbackpopup-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes feedbackpopup-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@media (max-width: 520px) {\n  .feedbackpopup-toggle {\n    top: auto;\n    right: 12px;\n    bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n    min-height: 40px;\n    padding: 9px 12px;\n    border-radius: 8px;\n    transform: none;\n    writing-mode: horizontal-tb;\n  }\n\n  .feedbackpopup-toggle:active {\n    transform: translateY(1px);\n  }\n\n  .feedbackpopup-form menu {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .feedbackpopup-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
